module.exports = __webpack_public_path__ + "static/media/test15_1.d07210c1.png";